<script setup>
// The card shown when the assistant has no script yet: it offers the base scripts the catalog says can be
// imported ("Import script") and brings one in as the first draft. Importing does not publish anything.
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { Button } from 'dashboard/components-next/polaris/ui/button';
import OptionSelect from 'dashboard/components-next/polaris/cards/OptionSelect.vue';

const props = defineProps({
  importable: { type: Array, default: () => [] },
  importing: { type: Boolean, default: false },
});
const emit = defineEmits(['import']);
const { t } = useI18n();

const chosen = ref('');
const options = computed(() =>
  props.importable.map(key => {
    const words = String(key).replace(/[_-]+/g, ' ').trim();
    return {
      value: key,
      label: words.charAt(0).toUpperCase() + words.slice(1),
    };
  })
);
</script>

<template>
  <section
    class="grid gap-3 rounded-polaris-xl border border-solid border-polaris-border bg-polaris-card p-4"
    data-script-import
  >
    <div class="grid gap-1">
      <h2 class="type-polaris-card-title">
        {{ t('POLARIS.ASSISTANTS.SCENARIOS.SCRIPT.IMPORT.TITLE') }}
      </h2>
      <p class="max-w-prose type-polaris-body text-polaris-muted-foreground">
        {{ t('POLARIS.ASSISTANTS.SCENARIOS.SCRIPT.IMPORT.DESCRIPTION') }}
      </p>
    </div>
    <div class="flex flex-wrap items-center gap-2">
      <OptionSelect
        v-model="chosen"
        :options="options"
        :placeholder="
          t('POLARIS.ASSISTANTS.SCENARIOS.SCRIPT.IMPORT.PLACEHOLDER')
        "
        :aria-label="
          t('POLARIS.ASSISTANTS.SCENARIOS.SCRIPT.IMPORT.PLACEHOLDER')
        "
        :disabled="!options.length"
        class="max-w-80"
      />
      <Button
        type="button"
        :disabled="!chosen || importing"
        data-script-import-action
        @click="emit('import', chosen)"
      >
        {{ t('POLARIS.ASSISTANTS.SCENARIOS.SCRIPT.IMPORT.ACTION') }}
      </Button>
    </div>
    <p
      v-if="!options.length"
      class="type-polaris-caption text-polaris-muted-foreground"
    >
      {{ t('POLARIS.ASSISTANTS.SCENARIOS.SCRIPT.IMPORT.NONE') }}
    </p>
  </section>
</template>
